import React, { Component } from 'react';

export default class News extends Component {
    render () {
        return<div>
            Here will be some news
        </div>
    }
}